export enum Panels {
	ORDERS,
	ORDERS_DETAILS,
	MAP
}

const initialListSize = 20;
export const defaultSizes = [initialListSize, 100 - initialListSize, 0];

export const calcSectionsSizes = (sizes: number[], panel: Panels, isCollapse: boolean): number[] => {
	const isSectionClose = (currPanel: Panels) => sizes[currPanel] === 0;
	const orderSizes = sizes[Panels.ORDERS] !== 100 ? sizes[Panels.ORDERS] : defaultSizes[Panels.ORDERS];

	const fullWidth = 100 - orderSizes;
	const halfWidth = fullWidth / 2;

	let details = 0;
	let map = 0;

	switch (panel) {
		case Panels.ORDERS_DETAILS:
			if (isCollapse) {
				map = fullWidth;
			} else {
				if (isSectionClose(Panels.MAP)) {
					details = fullWidth;
				} else {
					details = halfWidth;
					map = halfWidth;
				}
			}
			break;
		case Panels.MAP:
			if (isCollapse) {
				details = fullWidth;
			} else {
				if (isSectionClose(Panels.ORDERS_DETAILS)) {
					map = fullWidth;
				} else {
					details = halfWidth;
					map = halfWidth;
				}
			}
	}

	return [orderSizes, details, map];
};
